import axios from 'axios'
import qs from 'qs'
import {Message} from 'element-ui'
import store  from '../store'
import {
  cookie
} from '@/util'
export let Global_Url = ''
if (process.env.NODE_ENV === "development") {
  Global_Url = '/api'
  // Global_Url = location.hash.includes('py=1') ? 'https://api.ccqf.vip' : 'https://api.ccqf.vip'
}else {
  Global_Url = 'https://api.cfovip.net'
}

function setRequest(axios,mask,url) {
  axios.$$state = 'pendding'
  axios.$$url = url
  store._mutations.updateLoadingState[0]({
    state: true,
    axios
  })
  axios.interceptors.request.use(config => {
    // config.headers['X-Authorization'] = cookie.get('token')
    return config
  })
}

function checkNodeEnv(){
  if (process.env.NODE_ENV === "development") {
    return true
  }else {
    return false
  }
}

function setResponse(axios,isReturnData) {
  axios.interceptors.response.use(res => {

    axios.$$state = 'finished'
    store._mutations.updateLoadingState[0]({
      state: false,
      axios
    })
    if(res.data.code === 200) {
      if(isReturnData){
        return Promise.resolve(res.data)
      }else{
        return Promise.resolve(res.data.result)
      }
    }else {
      return Promise.reject({code:res.data.code,message: res.data.message,result:res.data.result})
    }
  })
}


export const newAxios = function (config,type,mask,isReturnData = false) {
  const headers = {}
  config.url = Global_Url + config.url
  config.method === 'get' ? '' : config.method = 'post'
  if(!config.data) config.data = {}
  if(Object.prototype.toString.call(config.data) === '[object Object]') {
    config.userId ? config.data.userId = localStorage.getItem('userId') : ''
  }
  if(type === 'json') {
    headers['Content-Type'] = 'application/json'
  }else if(type === 'multipart'){
    headers['Content-Type'] = 'multipart/form-data'
  } else {
    config.data ? config.data = qs.stringify(config.data) : ''
  }
  const myAxios = axios.create({
    ...config,
    headers
  })
  setRequest(myAxios,mask === false ? false : true,config.url)
  setResponse(myAxios,isReturnData)

  return myAxios
}




// WEBPACK FOOTER //
// ./src/ajax/index.js